$(function(){

	var $uploadWrapper = $('#upload_wrapper');
	if(!$uploadWrapper.length){
		return false;
	}

	var threshold = 0.93;
    var app = null;
	// var app = new Clarifai.App({
	// 	apiKey: 'ea746f008b50445aa47ffb018f3d5681',
	// });

	$('#albumchoice').on('change', function(e){
		document.location = window.location.origin + '/aupload/' + $(this).val();
	});

	var last = null;
	$('#upload_wrapper').on('focus', '.tags-text', function(e){
		last = $(this).val();
	});

	$('#upload_wrapper').on('blur', '.tags-text', function(e){
		var val = $(this).val();
		if(val != last){
			$(this).save();
		}
	});

	$('#upload_wrapper').on('click', '.save-tags', function(e){
		$(this).save();
	});

	$('#upload_wrapper').on('click', '.auto-tags', function(e){
		$(this).autoTag();
	});

	function saveSort(){
		var $cells = $('#imagecells > div.imagecell');
		if($cells.length){
			var token = $($cells[0]).data('token');

			var items = {};
			$cells.each(function(i){
				items[parseInt($(this).data('file'))] = i + 1;
			});

			$.post(window.location.origin + '/aupload/fsaveorder', {
				order: items,
				_token: token,
			}, function(result){
				console.log(result);
			});
		}
	}

	// $uploadWrapper.find('#imagecells:first').sortable({
	// 	stop: function(e, ui){
	// 		saveSort();
	// 	}
	// });

	$.fn.autoTag = function(){
		var $self = $(this);
		var $imagecell = $self.parents('.imagecell:first');
		var image = $imagecell.data('name');
		var $tagField = $imagecell.find('.tags-text:first');
		var tags = $tagField.val();
		tags = tags ? tags.split(',') : [];
		var path = window.location.origin+"/img/large/"+image;
		//var path = "http://austinweidler.com/images/Handcraft1%20(render%20open).jpg";

		app.models.predict(Clarifai.GENERAL_MODEL, path).then(
			function(response) {
				for(var i=0; i<response.outputs.length; i++){
					var concepts = response.outputs[i].data.concepts;

					for(var j=0; j<concepts.length; j++){
						var tag = concepts[j].name;
						var value = concepts[j].value;

						if(value > threshold && tag.indexOf(',') == -1 && $.inArray(tag.trim(), tags) == -1){
							tags.push(tag);
						}
					}
				}

				var tagstring = tags.join(',');
				$tagField.val(tagstring);
				$self.save();
			},
			function(err) {
				console.log(err);
			}
		);
	}

	$.fn.save = function(){
		var $imagecell = $(this).parents('.imagecell:first');
		var tags = $imagecell.find('.tags-text:first').val();
		var file = $imagecell.data('file');
		var token = $imagecell.data('token');

		$.post(window.location.origin + '/aupload/fsave/'+parseInt(file), {
			file: file,
			tags: tags,
			_token: token,
		}, function(result){
			console.log(result);
		});
	}
});
